import { createSlice } from '@reduxjs/toolkit';
import { Action } from 'redux';
import { fetchAccessedStatuses } from 'api/statuses';
import { AppThunk } from 'store/store';
import { RouteItem, routeList } from '../../router/route-list';

export interface MenuItemModel {
    id?: number;
    name: string;
    icon?: string | undefined;
    path?: string;
    permissions?: string[];
    items?: MenuItemModel[];
    doubleSelect?: boolean;
    code?: string;
    count?: number;
}

export interface MenuState {
    items: MenuItemModel[];
}

function buildMenu(list: RouteItem[]): MenuItemModel[] {
    return list
        .filter((l) => !l.hidden)
        .map(
            (l) =>
                ({
                    name: l.name,
                    path: l.path,
                    icon: l.icon,
                    items: l.items ? buildMenu(l.items) : null,
                    permissions: l.permissions,
                    count: 0,
                } as MenuItemModel)
        );
}

export const initialState: MenuState = { items: [...buildMenu(routeList)] };

function findByName(name: string, items: MenuItemModel[]): MenuItemModel | undefined {
    for (const item of items) {
        if (item.name === name) {
            return item;
        } else if (item.items && item.items.length > 0) {
            return findByName(name, item.items);
        }
    }
}

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setMenuItems(
            state,
            action: Action & {
                payload: { name: string; items: MenuItemModel[] };
            }
        ) {
            const { name, items } = action.payload;
            const existingItems = state.items.concat();
            const foundIndex = existingItems.findIndex((i) => i.name === name);
            const currentItem = existingItems[foundIndex];
            currentItem.items = items;
            state.items = existingItems;
        },
        setMenuBadgeCount(
            state,
            action: Action & {
                payload: { name: string; count: number };
            }
        ) {
            const { name, count } = action.payload;
            const list = state.items.concat();

            const item = findByName(name, list);
            if (item) {
                item.count = count;
                state.items = list;
            }
        },
    },
});

export const { setMenuItems, setMenuBadgeCount } = menuSlice.actions;

export default menuSlice.reducer;

export const { getMenuItems } = {
    getMenuItems(state: { menu: MenuState }) {
        return state.menu.items;
    },
};

export const loadRequestStatuses = (): AppThunk => async (dispatch) => {
    try {
        const data = await fetchAccessedStatuses();
        dispatch(
            setMenuItems({
                name: 'OrdersByStatuses',
                items: data.map((i) => ({
                    id: Number(i.id),
                    name: i.description,
                    path: `/cabinet/requests/${i.id}`,
                    doubleSelect: i.is_mass_sampling,
                    code: i.code,
                })),
            })
        );
    } catch (e) {
        console.log(e);
    }
};
